export const code_activity_type = [
  {
    id: 1,
    code: "wait",
    description: "Wait",
  },
  {
    id: 2,
    code: "Webhook",
    description: "Webhook",
  },
  {
    id: 3,
    code: "Send Email",
    description: "Send Email",
  },
];
